// removed by extract-text-webpack-plugin
module.exports = {"form":"phone-confirmation__form__1yGrf","error":"phone-confirmation__error__1n0W4","error-transparent":"phone-confirmation__error-transparent__1EoCW","code-input":"phone-confirmation__code-input__2y9yk","action-link":"phone-confirmation__action-link__8eNPZ","button-wrapper":"phone-confirmation__button-wrapper__2cSSj","button":"phone-confirmation__button__2To76","name-fields":"phone-confirmation__name-fields__1UNns","icon-wrapper":"phone-confirmation__icon-wrapper__39BsS","left-chevron-icon":"phone-confirmation__left-chevron-icon__kNhyv"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/components/phone-confirmation.scss
// module id = 1759
// module chunks = 1